import styled from "styled-components";
import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";
import {hexToRgba} from "../../../../themes/hex-to-rgba";

const BonusAndCashBalanceDefaultBox = styled.div`
    /* .bonus-and-cash-balance */
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 1rem 0;
    ${({theme}) => theme.font.presets.body};
    font-size: 1.4rem;
    letter-spacing: 1px;
    border-top: 1px solid #303030;
    border-bottom: 1px solid #303030;
    padding-left: 4px;
    padding-right: 4px;
`;

const BonusAndCashBalanceMrGreenBox = styled(BonusAndCashBalanceDefaultBox)`
    border-top: 1px solid ${({theme}) => hexToRgba(theme.colors.boxBorderLighter, 0.2)};
    border-bottom: 1px solid ${({theme}) => hexToRgba(theme.colors.boxBorderLighter, 0.2)};
`;

export const BonusAndCashBalanceBox = styledByTheme(BonusAndCashBalanceMrGreenBox).forMrGreen(BonusAndCashBalanceMrGreenBox).apply();
